import React from 'react';
import LandingNav from '../components/LandingNav';
import Footer from '../components/Footer';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <LandingNav />
      <div className="legal-content">
        <h1>Privacy Policy</h1>
        <p><strong>Last Updated:</strong> January 2025</p>
        <p>
          Trckle ("we," "us," "our") provides a social-media management platform that enables users
          to schedule posts, manage multiple accounts, and view analytics across supported platforms.
          This Privacy Policy explains how we collect, use, store, and protect your information when you
          use Trckle.
        </p>

        <h2>1. Information We Collect</h2>
        
        <h3>A. Account Information</h3>
        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Password (encrypted/hashed)</li>
          <li>Platform settings and preferences</li>
        </ul>

        <h3>B. Connected Social Accounts</h3>
        <p>When you connect a social media profile, we may receive:</p>
        <ul>
          <li>OAuth tokens</li>
          <li>Platform-provided profile details</li>
          <li>Permissions for publishing and analytics</li>
        </ul>
        <p>We never store your social media passwords.</p>

        <h3>C. Usage Data</h3>
        <ul>
          <li>IP address</li>
          <li>Device data</li>
          <li>Browser type</li>
          <li>Interaction logs</li>
        </ul>

        <h3>D. Scheduled Content</h3>
        <p>We store user-created content such as:</p>
        <ul>
          <li>Captions</li>
          <li>Images or media metadata</li>
          <li>Scheduled posting times</li>
          <li>Drafts</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>Operate and improve the Trckle platform</li>
          <li>Authenticate user accounts</li>
          <li>Schedule and publish posts</li>
          <li>Display analytics and performance data</li>
          <li>Provide customer support</li>
          <li>Maintain platform security</li>
        </ul>
        <p>Your data is never sold.</p>

        <h2>3. Data Storage & Security</h2>
        <p>
          We use encryption, secure token handling, and industry-standard practices to protect your
          data. OAuth tokens are encrypted at rest. Only authorized team members may access system
          data as required to maintain the service.
        </p>

        <h2>4. Information Sharing</h2>
        
        <h3>A. With Connected Platforms</h3>
        <p>
          We share only the data necessary to perform platform-approved actions such as posting or
          retrieving analytics.
        </p>

        <h3>B. With Service Providers</h3>
        <p>
          We may use cloud hosting, analytics, and email service providers to support Trckle. All
          vendors are contractually required to follow data-protection standards.
        </p>

        <h2>5. Data Retention</h2>
        <p>
          We retain user data only as long as necessary to operate the service, meet legal
          obligations, or as required for user-requested features. You may request deletion at any
          time.
        </p>

        <h2>6. Your Rights</h2>
        <p>You may:</p>
        <ul>
          <li>Delete your account</li>
          <li>Request deletion of uploaded content</li>
          <li>Revoke connected account permissions at any time</li>
          <li>Request a copy of your data</li>
        </ul>
        <p>Contact us at: <strong>trcklesocial@gmail.com</strong></p>

        <h2>7. Children's Privacy</h2>
        <p>Trckle is not intended for users under 13 years of age.</p>

        <h2>8. Updates</h2>
        <p>
          This Privacy Policy may be updated periodically. Continued use of Trckle implies
          acceptance of updated terms.
        </p>

        <h2>9. Contact</h2>
        <p><strong>Email:</strong> trcklesocial@gmail.com</p>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
